import React from 'react';
import { SubcategoryResponse } from '../../../types/api/catalogs';
import { Stack, Text, IconButton } from '@primer/react'
import { PencilIcon, TrashIcon, ChevronRightIcon } from '@primer/octicons-react';

interface SubCategoryViewProps {
    subcategory: SubcategoryResponse;
    onSubCategoryClick: () => void;
    onEditClick: () => void;
    onDeleteClick: () => void;
}

export const SubCategoryView: React.FC<SubCategoryViewProps> = ({ subcategory, onSubCategoryClick, onEditClick, onDeleteClick }) => {
    return (
        <div className={`bg-white border border-border rounded-lg h-[72px] w-auto mx-auto flex items-center justify-center px-4 mb-4`} style={{ width: '100%' }}>
            <Stack direction="horizontal" align="center" className='w-full'>
                <div className="flex items-center gap-4 overflow-hidden" style={{ width: 'calc(100% - 80px)' }}>
                    <div className="flex flex-col min-w-0">
                        <Stack direction="horizontal" align="center">
                            <div
                                onClick={onSubCategoryClick}
                                className="grid grid-cols-[1fr_auto] items-center h-[20px] cursor-pointer gap-2">
                                <Text
                                    className='truncate'
                                    fontSize='14'
                                    fontWeight="semibold"
                                    color="fg.default">
                                    {subcategory.title}
                                </Text>
                                <ChevronRightIcon size={16} className="ml-auto" />
                            </div>
                        </Stack>
                        <Text fontSize={14} color="fg.muted" display="block">
                            {subcategory.adsCount} объявлений
                        </Text>
                    </div>
                </div>
                <Stack direction="horizontal" align="center" gap="condensed">
                    <IconButton
                        onClick={onEditClick}
                        icon={PencilIcon}
                        variant="default"
                        aria-label="Изменить" />
                    <IconButton
                        onClick={onDeleteClick}
                        icon={TrashIcon}
                        variant="danger"
                        aria-label="Удалить" />
                </Stack>
            </Stack>
        </div>
    );
};